//Keycloak email regex is more restrictive than formik validation. for example some chars like äéà are forbidden.
export const keycloakEmailRegex = /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*$/;
